import { forwardRef } from 'react'
import { Assignee, PostStatusPropertyValue, type PropertyValue } from 'api/clients/PropertyClient'
import Styles from '../PropertyValue.module.scss'
import { isString } from 'lodash'
import { Tag } from 'common/OptionSelect/Tag'
import { PostStatusDropdown } from 'components/PostStatusDropdown/PostStatusDropdown'
import { Pressable } from '@react-aria/interactions'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { AD_DESIGN_CHANNELS } from 'components/NewFileModal/Types'

interface Props {
  propertyValue?: PropertyValue & { value: PostStatusPropertyValue }
  onSelect: (value: PostStatusPropertyValue) => void
  assignee: Assignee
}

const PostStatus = observer(
  forwardRef<HTMLDivElement, Props>(({ propertyValue, assignee }, ref) => {
    const { files } = useRootStore()
    const file = files.get(assignee.id)

    if (!isString(propertyValue?.value)) return <></>
    const fileChannel = file?.channel_emoji || file?.channel
    if (fileChannel && AD_DESIGN_CHANNELS.includes(fileChannel)) return <></>

    return (
      <div ref={ref} className={Styles.postStatusContainer}>
        <PostStatusDropdown assignee={assignee}>
          <Pressable>
            <div style={{ width: '100%' }}>
              <div style={{ width: 'fit-content' }}>
                <Tag color={propertyValue?.meta?.color as string}>{propertyValue?.value}</Tag>
              </div>
            </div>
          </Pressable>
        </PostStatusDropdown>
      </div>
    )
  }),
)

export default PostStatus
